exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n  .StyleDiv__PageHeader-module___38_js a,\n  a:visited,\n  a:active {\n    color: #0183D5;\n    text-decoration: none;\n  }", ""]);

// Exports
exports.locals = {
	"StyleDiv": "StyleDiv__PageHeader-module___38_js"
};